import React from 'react';
import AkEmptyState from '@atlaskit/empty-state';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';

export const EmptyState = ({
	message,
	header = '',
	imageUrl,
}: {
	message: string;
	header?: string;
	imageUrl: string;
}) => (
	<>
		<FireOperationalAnalytics eventName="customersOrgsEmptyState loaded" />
		<AkEmptyState
			header={header}
			imageWidth={gridSize * 62.5}
			maxImageWidth={gridSize * 62.5}
			imageHeight={gridSize * 37.5}
			maxImageHeight={gridSize * 37.5}
			description={message}
			imageUrl={imageUrl}
			size="wide"
		/>
	</>
);
